var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 548.244 548.244",
    height: 512,
    viewBox: "0 0 548.244 548.244",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Icon_00000073707063774068171800000011646428281727846063_",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m316.124 50.994c10.557 0 19.125 8.568 19.125 19.125s-8.568 19.125-19.125 19.125h-220.499c-31.697 0-57.375 25.678-57.375 57.375v306c0 31.697 25.678 57.375 57.375 57.375h306c31.697 0 57.375-25.678 57.375-57.375v-220.499c0-10.557 8.568-19.125 19.125-19.125s19.125 8.568 19.125 19.125v220.499c0 52.81-42.815 95.625-95.625 95.625h-306c-52.811 0-95.625-42.815-95.625-95.625v-306c0-52.811 42.814-95.625 95.625-95.625z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.821 156.564-166.796 166.795c-2.091 2.091-4.641 3.672-7.471 4.616l-81.141 27.03c-6.859 2.295-14.433.51-19.559-4.615-5.126-5.126-6.911-12.699-4.615-19.559l27.03-81.141c.943-2.831 2.524-5.381 4.615-7.472l166.796-166.795zm-54.086-108.197 31.595-31.594c22.389-22.364 58.676-22.364 81.065 0l.076.076c22.364 22.389 22.364 58.675 0 81.064l-31.594 31.594z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.a6fc21a2685fc7fdb7da6faa1985946c.svg";
export { ForwardRef as ReactComponent };